<template>
    <v-col class="mb-md-0 px-0 pt-0">
        <v-combobox
            ref="input"
            v-model="model"
            :items="items"
            :loading="isLoading"
            :search-input.sync="search"
            :placeholder="placeholder"
            class="search-input"
            item-text="displayString"
            item-value="typeRelativeId"
            solo
            outlined
            rounded
            dense
            flat
            filled
            no-filter
            allow-overflow
            maxlength="40"
            autocomplete="off"
            clearable
            hide-no-data
            hide-details
            persistent-hint
            return-object
            validate-on-blur
            :prepend-inner-icon="'icon-forma-1-copy-4'"
            :menu-props="{
              contentClass:
                'smart-combo display-18   px-3 scrollbar-3 text-right menu-props-class',
              closeOnClick: false,
              closeOnContentClick: false,
              openOnClick: false,
              bottom: true,
            }"
            @blur="model = search"
        ></v-combobox>
    </v-col>
</template>


<script>
import drushim_lodash from 'lodash';
import * as lib from '@/components/HomePageComponents/AutoComplete/lib';

export default {
  name: 'WhatField',
  props: {
    placeholder: {
      type: String,
      default: ''
    },

    keywordJD: {
      type: String,
      required: false,
      default: ''
    }
  },

  data() {
    return {
      isLoading: false, // fetching data in progress
      isSearching: false, // user is entering search input - used to show empty list (see @EmptyList)
      search: null, // search value
      resultList: null, // server response
      cache: new Map(),
      disableSend: true,
      select: ''
    };
  },

  computed: {
    items() {
      const emptyList = this.emptyList();
      return emptyList || lib.getItems(this.resultList);
    },
    model: {
      get() {
        return this.keywordJD ? this.keywordJD : '';
      },
      set(val) {
        this.select = val;
      }
    }
  },

  watch: {
    // triggers autocomplete
    search(newVal) {
      if (newVal === '') {
        this.search = '';
        this.model = null;

        return;
      }

      this.isSearching = true;
      this.$emit('search', newVal);
    },

    model() {
      if (!drushim_lodash.isNil(this.model)) this.disableSend = false;
    },

    select() {
      if (this.select?.displayString) {
        this.$emit('whatSearch', this.select.displayString);
      } else if (this.select) this.$emit('whatSearch', this.select);
      else {
        this.$emit('deleteWhat');
      }
    }
  },

  mounted() {
    this.compClass;
    this.onSearch = drushim_lodash.debounce(this.onSearch, 250);

    this.$on('search', this.onSearch);
    this.setInputValueAsProp();
  },

  methods: {
    setInputValueAsProp() {
      // set initial value if provided as prop
      if (this.keywordJD) {
        this.model = this.keywordJD;
      }
    },

    onEnter() {
      this.submitSearch();
    },

    onSearch(newVal) {
      if (!newVal) return;
      if (!drushim_lodash.isString(newVal) || drushim_lodash.isEmpty(newVal.trim())) return;
      // check before continue
      newVal = newVal.trim();
      if (this.isLoading) {
        this.isSearching = false;
        return;
      }

      this.isLoading = true;
      //to avoid second loading for excisting selection
      if (
        this.search === this.keywordJD ||
        this.search === this.select?.displayString
      ) {
        this.isLoading = false;
        return this.keywordJD;
      }

      this.loadSearchSuggestions(newVal)
        .catch(err => console.log(err))
        .then(res => {
          this.resultList = drushim_lodash.cloneDeep(res.resultList);
          return res;
        })
        .finally(() => {
          this.isLoading = false;
          this.isSearching = false;
        });
    },

    /**
     * Load suggestions by search String
     * @param {string} searchVal - search value
     * @returns {Promise} fetch request resolved with suggestions data
     */
    loadSearchSuggestions(searchVal) {
      if (this.cache.has(searchVal)) {
        return this.cache.get(searchVal);
      }

      const data = {
        parameters: [
          { name: 'suggestPrefix', value: searchVal },
          {
            name: 'suggestTypes',
            value: [lib.returnRelevantSearchFlags()].join()
          }
        ]
      };

      return lib.loadSuggestions({ data }, this.$axios).then(res => {
        this.cache.set(searchVal, Promise.resolve(res));
        return res;
      });
    },

    emptyList() {
      const emptyList = [];

      // if empty search string
      if (!this.search) return emptyList;

      // if still searching
      if (this.isSearching) return emptyList;

      // item already selected from list
      if (drushim_lodash.get(this.model, 'displayString') === this.search) return emptyList;

      return null;
    }

  },

  beforeDestroy() {
    this.model = null;
    this.search = '';
    this.disableSend = true;
    this.$off('search');
  }
};
</script>

<style lang="scss" scoped>
</style>
